// extracted by mini-css-extract-plugin
export default {"buttonBase":"ButtonPrevious_buttonBase__NvVNx"};